import * as Scrivito from "scrivito"
import { useScrivitoPage } from "scrivito/hooks/useScrivitoPage"
import { ErrorPage } from "shared/ui/error-page/ErrorPage"

import { useScrollController } from "features/scroll-management/model/useScrollController"

import { PageObjClass } from "./PageObjClass"

Scrivito.registerComponent("dataErrorComponent", () => <ErrorPage />)

Scrivito.provideComponent(PageObjClass, ({ page }) => {
  useScrivitoPage()
  useScrollController()
  return (
    <Scrivito.ContentTag
      className="page bg-muted"
      content={page}
      attribute="body"
    />
  )
})
